import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

export const trackBannerImpression = (visibleText: string) => {
  sendGAEvent({
    event: 'banner_impressions',
    eventCategory: 'Site Wide Banner',
    eventAction: 'Banner Impression',
    eventLabel: visibleText,
    ecommerce: {
      promoView: {
        promotions: [
          {
            name: visibleText,
          },
        ],
      },
    },
  });
};

export const trackBannerClick = (
  evt: React.MouseEvent<HTMLAnchorElement>,
  linkText: string,
  linkHref: string,
) => {
  sendGALinkClickEvent(evt, {
    event: 'banner_clicks',
    eventCategory: 'Site Wide Banner',
    eventAction: 'Banner Click',
    eventLabel: linkText,
    destination_URL: linkHref,
    ecommerce: {
      promoClick: {
        promotions: [
          {
            name: linkText,
            id: linkHref,
          },
        ],
      },
    },
  });
};
